exports.reducePCVData = ({ data }) => {
    const purchaseRoasFilteredZeroes = data.filter(row => !!row.purchase_roas);
    const hasROASData = !!purchaseRoasFilteredZeroes.length;

    // Calculate average ROAS of all campaigns excluding records with 0 ROAS
    const sumPCVWithoutZeroes = purchaseRoasFilteredZeroes.reduce((acc, curr) =>
        acc + curr.purchase_conversion_value, 0);
    const sumSpendWithoutZeroes = purchaseRoasFilteredZeroes.reduce((acc, curr) => acc + curr.spend, 0);

    return {
        hasROASData,
        sumPCVWithoutZeroes,
        sumSpendWithoutZeroes
    };
};



// WEBPACK FOOTER //
// ./src/helpers/social.js